import FallbackUI from "./ErrorBoundary"
export default FallbackUI